import { useQuery } from 'react-query';
import { Box, CircularProgress } from '@mui/material';

interface SvgImageProps {
  logoUrl: string;
  width?: number | string;
  height?: number | string;
}

export const SvgImage = ({ logoUrl, width = 28, height = 28 }: SvgImageProps) => {
  const {
    data: svgContent,
    isLoading,
    isError,
  } = useQuery<string, Error>(
    ['svgImage', logoUrl],
    async () => {
      const response = await fetch(logoUrl, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) {
        throw new Error(`SVG fetch error: ${response.status}`);
      }
      return await response.text();
    },
    {
      suspense: false,
      onError: (err) => console.error(err.message),
    }
  );

  if (isLoading) {
    return <CircularProgress size={16} />;
  }

  if (isError || !svgContent) {
    return null;
  }

  return (
    <Box
      sx={{
        width: width,
        height: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        },
      }}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};
